import { formatCanvasGreetingDate } from "@/pages/canvas/config/canvasGreetings";
import { useEffect, useState } from "react";

/**
 * Wall clock for the greeting row. A leaf component so the periodic tick
 * re-renders only this span, never the browser below it.
 */
export function HomeClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 30_000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <span className="shrink-0 text-sm tabular-nums text-muted-foreground">
      {formatCanvasGreetingDate(now)}
    </span>
  );
}
